<app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

<!-- Modal -->
<div class="modal fade" id="applyCoupon" tabindex="-1" aria-labelledby="membershipModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="membershipModalLabel">{{"MEMBERSHIP.APPLY_COUPON"|translate}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeMembershipModal()"></button>
            </div>
            <div class="modal-body">

                <div>
                    <label>{{"MEMBERSHIP.PRICE" | translate}} </label>
                    <p>{{ finalPrice}} {{"MEMBERSHIP.EGY" | translate}}</p>
                </div>

                <form [formGroup]="CouponForm">

                    <div class="form-group col-md-12">
                        <div class="form-group col-md-12">
                            <label> {{"MEMBERSHIP.COUPON_CODE" | translate}}<span class="required">*</span></label>
                            <input type="text" formControlName="coupon" name="coupon" class="form-control" />
                        </div>

                        <div class="col-md-12 contact-form-style-2 d-flex gap-2">
                            <button type="submit" (click)="ApplyCoupon()"
                                class="btn btn-fill-out submit font-weight-bold mt-2 w-fit" name="submit" value="Submit"
                                [disabled]="price !== finalPrice">
                                {{"MEMBERSHIP.APPLY_COUPON" | translate}}
                            </button>

                            <button type="button" (click)="RemoveCoupon()" [hidden]="price === finalPrice"
                                class="btn bg-danger submit font-weight-bold mt-2 w-fit">
                                {{"MEMBERSHIP.REMOVE_COUPON" | translate}}
                            </button>
                        </div>

                    </div>
                </form>


            </div>
        </div>
    </div>
</div>